import { memo } from 'react';
import styles from './styles.module.scss';

const RewardsMarketplaceFeature = memo(() => (
  <div className={styles.container}>RewardsMarketplaceFeature</div>
));

RewardsMarketplaceFeature.displayName = 'RewardsMarketplaceFeature';

export default RewardsMarketplaceFeature;
